// extracted by mini-css-extract-plugin
export default {"overlayToaster":"Message_overlayToaster__BamRJ","extraClass":"Message_extraClass__w7rdL"};